import { cn } from '../../lib/cn.js';

export interface WordmarkProps {
  /** Show the subtle "by Estateflow" endorsement. */
  endorsement?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/** Convometry logomark: a conversation bubble containing measurement bars. */
export function Logomark({ className, size = 28 }: { className?: string; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden className={className}>
      <rect x="1" y="1" width="30" height="26" rx="9" fill="var(--cm-brand-primary)" />
      <path d="M8 27 L8 31 L14 27 Z" fill="var(--cm-brand-primary)" />
      <rect x="8" y="14" width="3.5" height="7" rx="1.5" fill="var(--cm-brand-on-primary)" />
      <rect x="14.25" y="9" width="3.5" height="12" rx="1.5" fill="var(--cm-brand-on-primary)" />
      <rect x="20.5" y="11.5" width="3.5" height="9.5" rx="1.5" fill="var(--cm-brand-on-primary)" opacity="0.85" />
    </svg>
  );
}

const TEXT = { sm: 'text-body', md: 'text-card-title', lg: 'text-heading' } as const;
const MARK = { sm: 22, md: 28, lg: 36 } as const;

export function Wordmark({ endorsement = false, size = 'md', className }: WordmarkProps) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <Logomark size={MARK[size]} />
      <span className="grid leading-none">
        <span className={cn('font-semibold tracking-[-0.01em] text-text-primary', TEXT[size])}>Convometry</span>
        {endorsement ? <span className="text-[11px] font-medium leading-2 text-text-muted">by Estateflow</span> : null}
      </span>
    </span>
  );
}
